import React, { useRef, useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { handleChangeDataModalAddCustomAddress } from '../../../../redux/actions/partials/modals/modalAddCustomAddress';
import { handleSetActiveAddress } from "../../../../redux/actions/pages/user/user";
import useOutsideClick from './hooks/useOutsideClick'; 
import apiRequest from '../../../../utils/apiRequest';
import { PROVINCES_GET, CITIES_POST, USERS_ADD_ADDRESS_POST } from '../../../../apis';


const ModalAddCustomAddress = (props) => {

	const dispatch = useDispatch();

	const { isMobile } = useSelector(state => state.general);
	const { isActive, showProvinceOptions, showCityOptions, provinces, provinceSelectedId, provinceSelectedTxt, cities, citySelectedTxt, citySelectedId, 
		address, plate, unit, postalCode, 
		provinceErr, cityErr, addressErr, plateErr, postalCodeErr } = useSelector(state => state.modalAddCustomAddress);
	const { glat, glng } = useSelector(state => state.modalAddAddress);
	const { token } = useSelector(state => state.login);
	const { isBackdropLoading } = useSelector(state => state.allLoaders);

	// استیت جدید برای استان‌های فیلترشده
	const [filteredProvinces, setFilteredProvinces] = useState([]);
	const [filteredCities, setFilteredCities] = useState([]);

	useEffect(() => {
	    if(isActive) 
	    	apiGetProvinces();
	}, [isActive]);

	const apiGetProvinces = () => {
		if(! isBackdropLoading) {
			apiRequest({
			    dispatch,
			    endpoint: PROVINCES_GET,
			    method: 'get',
			    onSuccess: (res) => {
			      	dispatch(handleChangeDataModalAddCustomAddress('provinces', res.provinces));
			      	setFilteredProvinces(res.provinces); // لیست اولیه
			    },
		  	});
		}
	};

	const apiGetCities = (provinceId) => {
		if(! isBackdropLoading) {
			apiRequest({
			    dispatch,
			    endpoint: CITIES_POST,
			    method: 'post',
			    data: {province: provinceId},
			    onSuccess: (res) => {
			      	dispatch(handleChangeDataModalAddCustomAddress('cities', res.cities));
			      	setFilteredCities(res.cities); // ست کردن شهرهای فیلترشده
			    },
		  	});
		}
	};

	const handleClose = () => {
		dispatch(handleChangeDataModalAddCustomAddress('showProvinceOptions', false));
		dispatch(handleChangeDataModalAddCustomAddress('showCityOptions', false));
		dispatch(handleChangeDataModalAddCustomAddress('provinceSelectedTxt', ''));
		dispatch(handleChangeDataModalAddCustomAddress('provinceErr', ''));
		dispatch(handleChangeDataModalAddCustomAddress('provinceSelectedId', false));
		dispatch(handleChangeDataModalAddCustomAddress('citySelectedTxt', ''));
		dispatch(handleChangeDataModalAddCustomAddress('cityErr', ''));
		dispatch(handleChangeDataModalAddCustomAddress('citySelectedId', false));
		dispatch(handleChangeDataModalAddCustomAddress('address', ''));
		dispatch(handleChangeDataModalAddCustomAddress('addressErr', ''));
		dispatch(handleChangeDataModalAddCustomAddress('plate', ''));
		dispatch(handleChangeDataModalAddCustomAddress('plateErr', ''));
		dispatch(handleChangeDataModalAddCustomAddress('unit', ''));
		dispatch(handleChangeDataModalAddCustomAddress('postalCode', ''));
		dispatch(handleChangeDataModalAddCustomAddress('postalCodeErr', ''));

		dispatch(handleChangeDataModalAddCustomAddress('isActive', false));
		setTimeout(() => {
            dispatch(handleChangeDataModalAddCustomAddress('isOpen', false));
        }, 250);
    };    

    const outerRef = useRef(null);
  	const centerBoxRef = useRef(null);
  	useOutsideClick(outerRef, centerBoxRef, handleClose, [ModalAddCustomAddress]);

    const handleChangeInputs = (event) => {
    	const {name, value} = event.target;
    	dispatch(handleChangeDataModalAddCustomAddress(name, value));
    };

 	const handleToggleShowProvinceOptions = () => {
 		dispatch(handleChangeDataModalAddCustomAddress('showProvinceOptions', !showProvinceOptions));
 	};

 	const handleToggleShowCityOptions = () => {
 		dispatch(handleChangeDataModalAddCustomAddress('showCityOptions', !showCityOptions));
 	};

 	const handleSelectProvince = (provinceId) => {
    	dispatch(handleChangeDataModalAddCustomAddress('provinceSelectedId', provinceId));
    	const provinceTxt = provinces.find(province => province.id === provinceId);
    	dispatch(handleChangeDataModalAddCustomAddress('provinceSelectedTxt', provinceTxt?.title ?? ''));
    	dispatch(handleChangeDataModalAddCustomAddress('showProvinceOptions', false));
    	setFilteredProvinces(provinces); // ریست فیلتر بعد از انتخاب
    	apiGetCities(provinceId);
    };

    const handleChangeInputProvince = (event) => {
    	const { value } = event.target;
    	dispatch(handleChangeDataModalAddCustomAddress('provinceSelectedId', false));
    	dispatch(handleChangeDataModalAddCustomAddress('provinceSelectedTxt', value));

    	// فیلتر استان‌ها
    	const filtered = provinces.filter((province) =>
    		province.title.toLowerCase().includes(value.toLowerCase())
    	);
    	setFilteredProvinces(filtered);
    };

    const handleSelectCity = (cityId) => {
    	dispatch(handleChangeDataModalAddCustomAddress('citySelectedId', cityId));
    	const cityTxt = cities.find(city => city.id === cityId);
    	dispatch(handleChangeDataModalAddCustomAddress('citySelectedTxt', cityTxt?.title ?? ''));
    	dispatch(handleChangeDataModalAddCustomAddress('showCityOptions', false));
    	setFilteredCities(cities); // ریست فیلتر بعد از انتخاب
    };

    const handleChangeInputCity = (event) => {
    	const {value} = event.target;
    	dispatch(handleChangeDataModalAddCustomAddress('citySelectedId', false));
    	dispatch(handleChangeDataModalAddCustomAddress('citySelectedTxt', value));

    	// فیلتر شهرها
		const filtered = cities.filter((city) =>
			city.title.toLowerCase().includes(value.toLowerCase())
		);
		setFilteredCities(filtered);
    };




	const submitForm = (event) => {
		event.preventDefault();

		if(! isBackdropLoading) {
			let error = false;

			if(! provinceSelectedId) {
				dispatch(handleChangeDataModalAddCustomAddress('provinceErr', 'استان را انتخاب کنید.'));
				error = true;
			}
			if(! citySelectedId) {
				dispatch(handleChangeDataModalAddCustomAddress('cityErr', 'شهر را انتخاب کنید.'));
				error = true;
			}
			if(address.length === 0) {
	    		dispatch(handleChangeDataModalAddCustomAddress('addressErr', 'آدرس را وارد کنید.'));
	    		error = true;
			}
	    	if(plate.length === 0) {
	    		dispatch(handleChangeDataModalAddCustomAddress('plateErr', 'پلاک را وارد کنید.'));
	    		error = true;
	    	}
	    	if(postalCode.length === 0) {
	    		dispatch(handleChangeDataModalAddCustomAddress('postalCodeErr', 'کدپستی را وارد کنید.'));
	    		error = true;
	    	}
	    	else if(postalCode.length !== 10) {
	    		dispatch(handleChangeDataModalAddCustomAddress('postalCodeErr', 'کدپستی  باید 10 رقم باشد.'));
	    		error = true;
	    	}

	    	if(! error)  {
	    		apiRequest({
				    dispatch,
				    endpoint: USERS_ADD_ADDRESS_POST,
				    method: 'post',
				    data: {city: citySelectedId, address, plate, unit, postalCode, glat, glng},
				    token: token, 
				    onSuccess: (res) => {
				      	dispatch(handleSetActiveAddress({
				      		id: res.address, 
				      		cityId: citySelectedId, 
				      		cityTitle: citySelectedTxt,
				      		address, 
				      		plate,
				      		unit,
				      		postalCode, 
				      		glat,
				      		glng,
				      		isPrimary: res.isPrimary,
				      	}));

				      	handleClose();
				    },
			  	});
	    	}
		    	
		}
	};


    return (

		<div ref={outerRef} className={`ReactModal__Overlay ${isActive ? 'ReactModal__Overlay--after-open' : ''}`} style={{position: 'fixed', inset: '0px', backgroundColor: 'rgba(0, 0, 0, 0.3)', zIndex: '11'}}>
			<div ref={centerBoxRef} className="ReactModal__Content ReactModal__Content--after-open bg-neutral-000 absolute overflow-y-hidden rounded-medium styles_Modal__TsaRp" tabIndex="-1" role="dialog" aria-modal="true"  style={ !isMobile ? {width: '550px'} : {width: '100%', maxHeight: '100vh', height: '100%'} }>
				<div className="flex flex-col h-full overflow-y-hidden styles_ModalLayout__y3Bs1" style={{paddingTop: '67px', paddingBottom: '80px'}}>
					<div className="w-full z-1 bg-neutral-000 fixed top-0 right-0 px-5" width="510" height="66.59375">
						<div className="flex items-center border-complete-b-200 py-4">
							<div class="grow text-h5">
								<div>
									<div class="flex items-center user-select-none">
										<div class="text-h5 text-neutral-900">
											افزودن آدرس جدید
										</div>
									</div>
								</div>
							</div>
							<div onClick={handleClose} class="flex cursor-pointer">
								<svg data-test-id="close-modal-icon-button" style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
									<use xlinkHref="#close"></use>
								</svg>
							</div>
						</div>
					</div>
					<div class="grow flex flex-col overflow-y-auto">
						<div class="grow flex flex-col styles_children__hHq5Q grow-0 px-4 py-4">
							<div class="w-full">
								<form>
									<div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4 mb-4">
										<div class="">
											<div class="select-none text-body-1 mb-2 text-neutral-700 mr-4">استان
												<label class="text-primary-700">*
												</label>
											</div>
											<div class="relative">
												<input type="hidden" required="" name="stateId" value="" />
												<input type="text" placeholder="" class={`font-iran-yekan h-12 w-full px-3 py-2 outline-none md:text bg-neutral-100 lg:bg-neutral-000 rounded border-complete styles_DropDown__input--bordered__jYaLg ${provinceErr.length > 0 ? 'styles_DropDown__input--error__EHFop' : 'lg:border-complete-200'}`} autocomplete="off" onChange={handleChangeInputProvince} value={provinceSelectedTxt} onClick={handleToggleShowProvinceOptions} />
												<div class="flex cursor-pointer absolute top-0 left-0 mt-3 ml-3 select-none cursor-pointer transform text-neutral-800">
													<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
														<use xlinkHref="#dropdown"></use>
													</svg>
												</div>
												{ showProvinceOptions &&
													<ul className="absolute z-1 w-full overflow-hidden overflow-y-auto rounded mt-1 bg-neutral-000 border-complete-200 user-select-none styles_DropDown__list__oBOIc">
														{
															filteredProvinces.map((province) => (
																<li key={province.id} data-value={province.id} 
																	onClick={(e) => handleSelectProvince(e.currentTarget.getAttribute('data-value'))} 
																	className="px-3 w-full select-none flex items-center text-body-1 cursor-pointer hover:bg-neutral-100 text-neutral-800">
																	{province.title}
																</li>
															))
														}
													</ul>
												}
											</div>
											{ provinceErr.length > 0 &&
												<div class="text-body-2 select-none text-hint-text-error pr-2">{provinceErr}</div>
											}
										</div>
										<div class="">
											<div class="select-none text-body-1 mb-2 text-neutral-700 mr-4">شهر
												<label class="text-primary-700">*
												</label>
											</div>
											<div class="relative">
												<input type="hidden" required="" name="cityId" value="" />
												<input type="text" placeholder="" class={`font-iran-yekan h-12 w-full px-3 py-2 outline-none md:text bg-neutral-100 lg:bg-neutral-000 rounded border-complete styles_DropDown__input--bordered__jYaLg ${cityErr.length > 0 ? 'styles_DropDown__input--error__EHFop' : 'lg:border-complete-200'}`} autocomplete="off" onChange={handleChangeInputCity} value={citySelectedTxt} onClick={handleToggleShowCityOptions} />
												<div class="flex cursor-pointer absolute top-0 left-0 mt-3 ml-3 select-none cursor-pointer transform text-neutral-800">
													<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
														<use xlinkHref="#dropdown"></use>
													</svg>
												</div>
												{ showCityOptions &&
													<ul className="absolute z-1 w-full overflow-hidden overflow-y-auto rounded mt-1 bg-neutral-000 border-complete-200 user-select-none styles_DropDown__list__oBOIc">
														{
															filteredCities.map((city) => (
																<li key={city.id} data-value={city.id} 
																	onClick={(e) => handleSelectCity(e.currentTarget.getAttribute('data-value'))} 
																	className="px-3 w-full select-none flex items-center text-body-1 cursor-pointer hover:bg-neutral-100 text-neutral-800">
																	{city.title}
																</li>
															))
														}
													</ul>
												}
											</div>
											{ cityErr.length > 0 &&
												<div class="text-body-2 select-none text-hint-text-error pr-2">{cityErr}</div>
											}
										</div>
									</div>
									<div class="flex flex-col mt-4 pb-3">
										<label class="FormComponentFrame_FormComponentFrame__PIUpy w-full FormComponentFrame_FormComponentFrame--normal__TQSOm">
											<div class="flex justify-between items-center">
												<p class="mb-2 mr-4 text-neutral-700 text-body-1">آدرس پستی
													<span class="text-primary-500">*
													</span>
												</p>
											</div>
											<div class={`FormComponentFrame_FormComponentFrame__input-container__BHc4I px-2 flex items-center relative text-neutral-800 bg-neutral-100 lg:bg-neutral-000 ${addressErr.length > 0 ? 'Input_InputWrapper--error__GDWAB' : 'Input_InputWrapper__d_4kf'}`}>
												<div class="grow text-body-3">
													<input type="text" name="address" autocomplete="off" required="" value={address} onChange={handleChangeInputs} class="px-2 TextField_TextField__input__hFMFl text-subtitle w-full TextField_TextField__bwN9_ TextField_TextField--secondary__w_vGF text-subtitle w-full py-5 lg:py-2 rounded-medium" />
												</div>
											</div>
											{ addressErr.length > 0 &&
											<p className="text-body-2 text-hint-text-error">{addressErr}</p>
											}
										</label>
										<span class="text-body-2 text-dark-neutral-600 mt-0.5">در صورت تغییر این بخش و ناهماهنگی آن با موقعیت مکانی، ممکن است ارسال سفارش با مشکل مواجه شود.
										</span>
									</div>
									<div class="grid grid-cols-2 gap-4 mt-4">
										<label class="FormComponentFrame_FormComponentFrame__PIUpy FormComponentFrame_FormComponentFrame--normal__TQSOm">
											<div class="flex justify-between items-center">
												<p class="mb-2 mr-4 text-neutral-700 text-body-1">پلاک
													<span class="text-primary-500">*
													</span>
												</p>
											</div>
											<div class={`FormComponentFrame_FormComponentFrame__input-container__BHc4I px-2 flex items-center relative text-neutral-800 bg-neutral-100 lg:bg-neutral-000 ${plateErr.length > 0 ? 'Input_InputWrapper--error__GDWAB' : 'Input_InputWrapper__d_4kf'}`}>
												<div class="grow text-body-3">
													<input type="text" name="plate" autocomplete="off" value={plate} onChange={handleChangeInputs} class="px-2 TextField_TextField__input__hFMFl text-subtitle w-full TextField_TextField__bwN9_ TextField_TextField--secondary__w_vGF text-subtitle w-full py-5 lg:py-2 rounded-medium"  />
												</div>
											</div>
											{ plateErr.length > 0 &&
											<p className="text-body-2 text-hint-text-error">{plateErr}</p>
											}
										</label>
										<label class="FormComponentFrame_FormComponentFrame__PIUpy FormComponentFrame_FormComponentFrame--normal__TQSOm">
											<div class="flex justify-between items-center">
												<p class="mb-2 mr-4 text-neutral-700 text-body-1">واحد
												</p>
											</div>
											<div class="FormComponentFrame_FormComponentFrame__input-container__BHc4I px-2 flex items-center relative text-neutral-800 bg-neutral-100 lg:bg-neutral-000 Input_InputWrapper__d_4kf">
												<div class="grow text-body-3">
													<input type="text" name="unit" autocomplete="off" value={unit} onChange={handleChangeInputs} class="px-2 TextField_TextField__input__hFMFl text-subtitle w-full TextField_TextField__bwN9_ TextField_TextField--secondary__w_vGF text-subtitle w-full py-5 lg:py-2 rounded-medium"  />
												</div>
											</div>
										</label>
									</div>
									<div class="mt-4">
										<label class="FormComponentFrame_FormComponentFrame__PIUpy w-full FormComponentFrame_FormComponentFrame--normal__TQSOm">
											<div class="flex justify-between items-center">
												<p class="mb-2 mr-4 text-neutral-700 text-body-1">کد‌پستی
													<span class="text-primary-500">*
													</span>
												</p>
											</div>
											<div class={`FormComponentFrame_FormComponentFrame__input-container__BHc4I px-2 flex items-center relative text-neutral-800 bg-neutral-100 lg:bg-neutral-000 ${postalCodeErr.length > 0 ? 'Input_InputWrapper--error__GDWAB' : 'Input_InputWrapper__d_4kf'}`}>
												<div class="grow text-body-3">
													<input type="text" name="postalCode" placeholder="باید ۱۰ رقمی باشد" autocomplete="off" maxlength="10" value={postalCode} onChange={handleChangeInputs} class="px-2 TextField_TextField__input__hFMFl text-subtitle w-full TextField_TextField__bwN9_ TextField_TextField--secondary__w_vGF text-subtitle w-full py-5 lg:py-2 rounded-medium"  />
												</div>
											</div>
											{ postalCodeErr.length > 0 &&
											<p className="text-body-2 text-hint-text-error">{postalCodeErr}</p>
											}
										</label>
									</div>
								</form>
							</div>
						</div>
					</div>
					<div class="w-full z-1 bg-neutral-000 px-5 py-4 fixed bottom-0 right-0 shadow-1-top" width="510" height="48">
						<div class="flex items-center justify-end">
							<button onClick={submitForm} class="relative flex items-center user-select-none styles_btn__Q4MvL text-button-1 styles_btn--large__1Muai styles_btn--primary__y0GEv styles_btn--wide__SUZl8 rounded-medium w-full" type="submit" data-cro-id="submit-address">
								<div class="flex items-center justify-center relative grow">
									تایید و ادامه
								</div>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>



        
    );
}

export default ModalAddCustomAddress;
